/**
 * Custom DIY Heartbeat icon — a heart outline with a heartbeat (EKG) line through it
 * and a small wrench accent. Used as the brand icon for all AI assistants.
 */
export function DIYHeartbeatIcon({ className = "h-6 w-6", color = "currentColor" }: { className?: string; color?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      {/* Heart outline */}
      <path d="M12 21C12 21 3 14.5 3 8.5C3 5.42 5.42 3 8.5 3C10.24 3 11.77 3.81 12.5 5.09C13.23 3.81 14.76 3 16.5 3C19.58 3 22 5.42 22 8.5C22 14.5 12 21 12 21Z" />
      {/* Heartbeat EKG line */}
      <polyline points="3,12 8,12 9.5,9 11,15 12.5,10 14,12 21,12" />
      {/* Small wrench accent at bottom-right */}
      <path d="M17.5 16.5L19 18L20.5 16.5" strokeWidth="1.5" />
    </svg>
  );
}
